import { ScopeType } from "sockapi/scope-types";
import NavTeamName from "components/NavTeamName";
import SiteNav from "components/SiteNav";
import { Spinner } from "components/Loading";
import { useGlobalScopeState } from "stores/ScopeStateStore";
import { useShouldDisplayAdmin } from "stores/ServerInteractionStore";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./HuntLib.css";

function MenuButton() {
  const shouldDisplayAdmin = useShouldDisplayAdmin();
  const openTaskCount = Object.values(
    useGlobalScopeState(ScopeType.ADMIN_QUEUE, shouldDisplayAdmin)?.tasks ?? {}
  )?.filter(({ respondTime }) => respondTime === undefined).length;
  return <>{openTaskCount > 0 ? <span>{openTaskCount}</span> : null}</>;
}

export const setup = () => {
  const siteNav = document.querySelector(".site-nav");
  if (siteNav !== null) {
    ReactDOM.createRoot(siteNav).render(
      <React.StrictMode>
        <SiteNav />
      </React.StrictMode>
    );
  }

  const navTeamName = document.getElementById("nav-team-name");
  if (navTeamName !== null) {
    ReactDOM.createRoot(navTeamName).render(
      <React.StrictMode>
        <NavTeamName />
      </React.StrictMode>
    );
  }

  const menuButton = document.querySelector("#menu-btn div");
  if (menuButton !== null) {
    ReactDOM.createRoot(menuButton).render(
      <React.StrictMode>
        <MenuButton />
      </React.StrictMode>
    );
  }

  const gameContainer = document.getElementById("game-root");
  if (gameContainer !== null) {
    const App = React.lazy(() => import("./App"));
    ReactDOM.createRoot(gameContainer).render(
      <React.StrictMode>
        <Suspense
          fallback={<Spinner size={128} text="Everything is going smoothly." />}
        >
          <App />
        </Suspense>
      </React.StrictMode>
    );
  }
};
